export const SET_ONTOLOGY_SUCCESS = 'ontology/SET_ONTOLOGY_SUCCESS';
export const SET_CONCEPTS_COUNT = 'ontology/SET_CONCEPTS_COUNT';
export const SET_LANGUAGES = 'ontology/SET_LANGUAGES';
export const SET_SELECTED_LANGUAGE = 'ontology/SET_SELECTED_LANGUAGE';
export const SET_UPDATE_INTERVAL = 'ontology/SET_UPDATE_INTERVAL';
export const SET_ALERT_TIMELINE = 'ontology/SET_ALERT_TIMELINE';
